import * as PERMISSIONS from './permissions'

const APP_ROUTES = {
  ROOT: {
    name: 'Root',
    link: '/',
    key: 'root',
  },
  ACCOUNT: {
    name: 'Account',
    link: '/account',
    key: 'account',
  },
  LOGIN: {
    name: 'Login',
    link: '/account/login',
    key: 'login',
  },
  LOGIN_EMAIL: {
    name: 'Login Email',
    link: '/account/login-email',
    key: 'login email',
  },
  LOGOUT: {
    name: 'Logout',
    link: '/account/logout',
    key: 'logout',
  },
  SETTINGS: {
    name: 'Settings',
    link: '/account/settings',
    key: 'settings',
  },
  USER_CREATE: {
    name: 'User Create',
    link: '/users/create',
    key: 'user-create',
    permissions: [PERMISSIONS.USER.CREATE],
  },
  USER_DETAILS: {
    name: 'User Details',
    link: '/users/:id',
    key: 'user-details',
    permissions: [PERMISSIONS.USER.GET, PERMISSIONS.USER.UPDATE],
  },
  OTHER: {
    name: 'Admin',
    link: '/admin',
    key: 'admin',
    permissions: [PERMISSIONS.REPORT.LIST],
    isNavigationTab: true,
    subMenuItems: {
      REPORTS: {
        name: 'Reports',
        link: '/reports',
        key: 'reports',
        isNavigationTab: true,
        permissions: [PERMISSIONS.REPORT.LIST],
      },
      USERS: {
        name: 'Users',
        link: '/users',
        key: 'users',
        permissions: [PERMISSIONS.USER.LIST],
        isNavigationTab: true,
      },
    },
  },
  MOBILE_APP_ONLY: {
    name: 'Mobile App Only',
    link: '/mobile-app-only',
    key: 'mobile-app-only',
    permissions: [PERMISSIONS.CHALLENGE.LIST],
    isNavigationTab: true,
    subMenuItems: {
      CHALLENGES: {
        name: 'Challenges',
        link: '/challenges',
        key: 'challenges',
        permissions: [PERMISSIONS.CHALLENGE.LIST],
        isNavigationTab: true,
      },
      FOOD_MOODS: {
        name: 'Food Moods',
        link: '/food-moods',
        key: 'food-moods',
        permissions: [PERMISSIONS.FOOD_MOOD.LIST],
        isNavigationTab: true,
      },
    },
  },
  CHALLENGE_DETAILS: {
    name: 'Challenge Details',
    link: '/challenges/:id',
    key: 'challenge-details',
    permissions: [PERMISSIONS.CHALLENGE.GET],
  },
  FOOD_MOODS_DETAILS: {
    name: 'Food Moods Details',
    link: '/food-moods/:id',
    key: 'food-mood-details',
    permissions: [PERMISSIONS.FOOD_MOOD.GET],
  },
  ALLERGENS: {
    name: 'Allergens',
    link: '/allergens',
    key: 'allergens',
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
    isNavigationTab: true,
  },
  ALLERGEN_DETAILS: {
    name: 'Allergen Details',
    link: '/allergens/:id',
    key: 'allergen-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  INGREDIENTS: {
    name: 'Ingredients',
    link: '/ingredients',
    key: 'ingredients',
    permissions: [PERMISSIONS.INGREDIENT.LIST],
    isNavigationTab: true,
    subMenuItems: {
      INGREDIENT_COMMON_NEGATIVE_SYNONYMS: {
        name: 'Common Negative Synonyms',
        link: '/ingredients/common-negative-synonyms',
        key: 'common-negative-synonyms',
        permissions: [
          PERMISSIONS.INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE.LIST,
        ],
      },
      INGREDIENT_SPECIAL_CASES: {
        name: 'Ingredient Special Cases',
        link: '/ingredients/special-cases',
        key: 'special-cases',
        permissions: [PERMISSIONS.INGREDIENT_SPECIAL_CASE.LIST],
      },
    },
  },
  INGREDIENT_DETAILS: {
    name: 'Ingredient Details',
    link: '/ingredients/:id',
    key: 'ingredient-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },

  INGREDIENT_SPECIAL_CASE_CREATE: {
    name: 'Create Special Case',
    link: '/ingredients/special-cases/create',
    key: 'special-cases-create',
  },
  INGREDIENT_SPECIAL_CASE_DETAILS: {
    name: 'Special Case Details',
    link: '/ingredients/special-cases/:id',
    key: 'special-case-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },

  DIET_CATEGORIES: {
    name: 'Diet Categories',
    link: '/diet-categories',
    key: 'diet-categories',
  },
  DIET_CATEGORIES_DETAILS: {
    name: 'Diet Category Details',
    link: '/diet-categories/:id',
    key: 'diet-category-details',
  },
  DIETS: {
    name: 'Diets',
    link: '/diets',
    key: 'diets',
    isNavigationTab: true,
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
  },
  DIET_DETAILS: {
    name: 'Diet Details',
    link: '/diets/:id',
    key: 'diet-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  DISH_TYPES: {
    name: 'Dish Types',
    link: '/dish-types',
    key: 'dish-types',
    isNavigationTab: true,
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
  },
  DISH_TYPE_DETAILS: {
    name: 'Dish Type Details',
    link: '/dish-types/:id',
    key: 'dish-type-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  COURSE_TYPES: {
    name: 'Course Types',
    link: '/course-types',
    key: 'course-types',
    isNavigationTab: true,
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
  },
  COURSE_TYPE_DETAILS: {
    name: 'Course Type Details',
    link: '/course-types/:id',
    key: 'course-type-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  CUISINE_TYPES: {
    name: 'Cuisine Types',
    link: '/cuisine-types',
    key: 'cuisine-types',
    isNavigationTab: true,
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
  },
  AWARDS: {
    name: 'Awards',
    link: '/awards',
    key: 'awards',
    isNavigationTab: true,
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
  },
  AWARD_DETAILS: {
    name: 'Award Details',
    link: '/awards/:id',
    key: 'award-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  CUISINE_TYPE_DETAILS: {
    name: 'Cuisine Type Details',
    link: '/cuisine-types/:id',
    key: 'cuisine-type-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  LOCATION_TYPE_CATEGORIES: {
    name: 'Location Type Categories',
    link: '/location-type-categories',
    key: 'location-type-categories',
  },
  LOCATION_TYPE_CATEGORIES_DETAILS: {
    name: 'Location Type Category Details',
    link: '/location-type-categories/:id',
    key: 'location-type-category-details',
  },
  LOCATION_TYPES: {
    name: 'Location Types',
    link: '/location-types',
    key: 'location-types',
    isNavigationTab: true,
    permissions: [PERMISSIONS.METADATA_TREE.LIST],
  },
  LOCATION_TYPE_DETAILS: {
    name: 'Location Type Details',
    link: '/location-types/:id',
    key: 'location-type-details',
    permissions: [PERMISSIONS.METADATA_TREE.GET],
  },
  DICTIONARY_WORDS: {
    name: 'Dictionary Words',
    link: '/dictionary-words',
    key: 'dictionary-words',
    isNavigationTab: true,
    permissions: [PERMISSIONS.DICTIONARY_WORD.LIST],
  },
}

export default APP_ROUTES
